import { SimplePageContentWrapper, SimplePageLayout, SimplePageHeader } from '@flexinet/ui-components';
import { RecordsTable } from '../../invoices/tables/RecordsTable';
import { ReportPageNavigation } from '../navigation/ReportPageNavigation';

export const InvoicesReportPage = () => {
  return (
    <SimplePageLayout
      pageHeader={<SimplePageHeader title="Invoices Report" />}
      pageNavigation={<ReportPageNavigation reportName="Invoices Report" />}
    >
      <SimplePageContentWrapper>
        <RecordsTable />
      </SimplePageContentWrapper>
    </SimplePageLayout>
  );
};